var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongDizhibu2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2v-.5a.5.5 0 00-.5.5H3zm0 12h-.5a.5.5 0 00.5.5V14zm10.5-8a.5.5 0 001 0h-1zM8 14.5a.5.5 0 000-1v1zm-5-12h10.5v-1H3v1zM3.5 14V2h-1v12h1zm10-11.5V6h1V2.5h-1zM8 13.5H3v1h5v-1zm5.5-11h1a1 1 0 00-1-1v1z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2v12.5",
    stroke: "#3F465C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5h1M2 8h1M2 11h1",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 11,
    r: 2.5,
    stroke: "#3F465C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.996 12.79a.5.5 0 10-.707.706l.707-.707zm.07 1.484a.5.5 0 10.708-.707l-.707.707zm-.777-.778l.778.778.707-.707-.778-.778-.707.707z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_dizhibu2.3dbe40ac.svg";
export { SvgTongyongDizhibu2 as ReactComponent };